import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TcPage } from '@tc/core';
import { IPageState } from '@tc/store';

@Component({
  selector: 'app-interlocuteurs-page',
  templateUrl: './interlocuteurs-page.component.html',
  styleUrls: ['./interlocuteurs-page.component.scss'],
})
export class InterlocuteursPageComponent extends TcPage implements OnInit {
  constructor(store: Store<any>) {
    super(store);
  }

  ngOnInit() {
    const pageInfo: IPageState = {
      title: 'interlocuteurs-page.title',
    };

    this.pageInfo = pageInfo;

    super.ngOnInit();
  }
}
